import styles from './service-description-card.module.scss';
import Button from '../Button/Button';
import { useNavigate } from 'react-router-dom';

const ServiceDescriptionCard = (props) => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <img
                src={require(`../../Assets/Images/Services/${props.icon}.png`)}
                alt={props.serviceName}
            />
            <h2>{props.title}</h2>
            <p>{props.briefDescription}</p>
            <Button
                buttonText='View Details'
                displayIcon={true}
                onClick={() => navigate(`/service/${props.id}`)}
            />
        </div>
    );
};

export default ServiceDescriptionCard;
